import { render, staticRenderFns } from "./HistoryEnsayos.vue?vue&type=template&id=6ac071fa&lang=true"
import script from "./HistoryEnsayos.vue?vue&type=script&lang=js"
export * from "./HistoryEnsayos.vue?vue&type=script&lang=js"
import style0 from "./HistoryEnsayos.vue?vue&type=style&index=0&id=6ac071fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports